/**
 * why we need re-render
 */
export var RenderReason;

(function (RenderReason) {
  RenderReason[RenderReason["CAMERA_CHANGED"] = 0] = "CAMERA_CHANGED";
  RenderReason[RenderReason["DISPLAY_OBJECT_CHANGED"] = 1] = "DISPLAY_OBJECT_CHANGED";
  RenderReason[RenderReason["NONE"] = 2] = "NONE";
})(RenderReason || (RenderReason = {}));

export var RenderingContext = 'RenderingContext';